import React from 'react';
import {useI18n} from '../../../../../../data/hooks/i18nHooks';
import StartNetworkingStep from '../../../StartNetworkingStep/StartNetworkingStep';
import { HASHTRIGGER_TEXT_SEARCH } from '../../../../EventParticipants/EventParticipantsHeader/ParticipantsTabs/TextSearchParticipants/TextSearchParticipants';

function StepSearch(props) {
    const {eventId} = props,
        i18n = useI18n();

    return <StartNetworkingStep href={`/events/${eventId}/participants#${HASHTRIGGER_TEXT_SEARCH}`}>{i18n['start.search_contacts']}</StartNetworkingStep>;
}

export default StepSearch;
